export interface ComparisonRow {
  without: string
  with: string
}
export const comparisonRows: ComparisonRow[] = [
  {
    without: 'Ponad 3 godziny tygodniowo na planowanie lekcji od zera',
    with: 'Otwierasz plan i tydzień jest gotowy',
  },
  {
    without: 'Tabulatury z internetu, które nie pasują do poziomu ucznia',
    with: 'Ćwiczenia ułożone według poziomu, gotowe do druku',
  },
  {
    without: 'Sześciu uczniów, sześć poziomów, zero planu',
    with: 'Jasna ścieżka od tygodnia 1 do tygodnia 16',
  },
  {
    without: 'Rodzice pytają: „Gdzie są efekty?”',
    with: 'Arkusze ocen, które pokazują postępy',
  },
  {
    without: 'Wchodzisz na lekcję nieprzygotowany',
    with: 'Wchodzisz, patrzysz i uczysz',
  },
]
export const problems: string[] = [
  'Twoje wieczory i weekendy znikają na przygotowywaniu lekcji od zera.',
  'Uczniowie w kółko powtarzają te same ćwiczenia i zaczynają się nudzić.',
  'Początkujący, średniozaawansowani i zaawansowani — nie da się ogarnąć wszystkich naraz.',
  'Nie wiesz, jak ułożyć logiczną progresję na cały semestr.',
  'Improwizujesz lekcję 5 minut przed przyjściem ucznia.',
  'Rodzice pytają: „Gdzie są efekty?”, a Ty nie masz czego im pokazać.',
]
